import { render, staticRenderFns } from "./header-wrap.vue?vue&type=template&id=728e5f49&scoped=true&"
import script from "./header-wrap.vue?vue&type=script&lang=js&"
export * from "./header-wrap.vue?vue&type=script&lang=js&"
import style0 from "./header-wrap.vue?vue&type=style&index=0&id=728e5f49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e5f49",
  null
  
)

export default component.exports